import { FETCH_MEMBERSHIP_PLANS_FAILURE, FETCH_MEMBERSHIP_PLANS_REQUEST, FETCH_MEMBERSHIP_PLANS_SUCCESS, FETCH_MEMBERSHIPS_FAILURE, FETCH_MEMBERSHIPS_REQUEST, FETCH_MEMBERSHIPS_SUCCESS } from "../actions/membershipActions"


const initialState = {
    memberShipPlans: [],
    isLoading: false,
    error: null,
    memberships: []
}

export const membershipReducer = (state = initialState, action) => {
    switch (action.type) {

        case FETCH_MEMBERSHIP_PLANS_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_MEMBERSHIP_PLANS_SUCCESS:
            return { ...state, memberShipPlans: action.payload, isLoading: false };

        case FETCH_MEMBERSHIP_PLANS_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        case FETCH_MEMBERSHIPS_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_MEMBERSHIPS_SUCCESS:
            return { ...state, memberships: action.payload, isLoading: false };

        case FETCH_MEMBERSHIPS_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        default:
            return state;
    }
}